'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Compass, Sparkles, Heart, User } from 'lucide-react';

interface NavItem {
  href: string;
  label: string;
  icon: React.ReactNode;
  iconActive: React.ReactNode;
}

const navItems: NavItem[] = [
  {
    href: '/',
    label: 'Entdecken',
    icon: <Compass size={24} strokeWidth={1.8} />,
    iconActive: <Compass size={24} strokeWidth={2.4} />,
  },
  {
    href: '/specials',
    label: 'Spezial',
    icon: <Sparkles size={24} strokeWidth={1.8} />,
    iconActive: <Sparkles size={24} strokeWidth={2.4} />,
  },
  {
    href: '/favorites',
    label: 'Favoriten',
    icon: <Heart size={24} strokeWidth={1.8} />,
    iconActive: <Heart size={24} strokeWidth={2.4} fill="var(--error)" />,
  },
  {
    href: '/profile',
    label: 'Profil',
    icon: <User size={24} strokeWidth={1.8} />,
    iconActive: <User size={24} strokeWidth={2.4} />,
  },
];

export default function BottomNav() {
  const pathname = usePathname();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 flex justify-center"
      role="navigation"
      aria-label="Hauptnavigation"
    >
      <div
        className="w-full max-w-mobile flex items-center justify-around px-2"
        style={{
          background: 'rgba(27,29,35,0.96)',
          borderTop: '1px solid var(--border)',
          backdropFilter: 'blur(16px)',
          WebkitBackdropFilter: 'blur(16px)',
          paddingTop: '10px',
          paddingBottom: 'calc(10px + env(safe-area-inset-bottom, 0px))',
        }}
      >
        {navItems.map((item) => {
          const isActive =
            item.href === '/'
              ? pathname === '/'
              : pathname === item.href || pathname.startsWith(item.href + '/');

          return (
            <Link
              key={`nav-${item.label.toLowerCase()}`}
              href={item.href}
              className="flex flex-col items-center justify-center gap-0.5 min-w-[60px] py-1 transition-all duration-150 active:scale-95"
              aria-label={item.label}
              aria-current={isActive ? 'page' : undefined}
            >
              <span
                className="transition-colors duration-150"
                style={{ color: isActive ? 'var(--primary)' : 'var(--muted-foreground)' }}
              >
                {isActive ? item.iconActive : item.icon}
              </span>
              <span
                className="text-[10px] font-medium transition-colors duration-150 leading-none"
                style={{ color: isActive ? 'var(--primary)' : 'var(--muted-foreground)' }}
              >
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}